import * as React from "react";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import Toast from "../../../../helper/Toast";
import EditDictionarySoratbleItemFormView from "./EditDictionarySoratbleItemFormView";
import DictionaryItem from "../../../../../model/dictionary/DictionaryItem";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";

interface IComponentProps {
	/**
	 * Title for edit modal
	 */
	title: string
	/**
	 * On successful updated item callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * item to edit.
	 */
	item: DictionaryItem;
	/**
	 * Update item action
	 * @param {string} itemId
	 * @param {DictionaryItem} item
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	onUpdateItem: (itemId: string, item: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Error handler
	 * @param err
	 * @returns {string | null}
	 */
	errorHandler?: (err: any) => string | null
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}


export default class EditDictionarySortableItemForm extends React.PureComponent<IComponentProps, IState> {
	public static defaultProps: Partial<IComponentProps> = {
		errorHandler: () => null
	};

	constructor(props: IComponentProps) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<EditDictionarySoratbleItemFormView title={this.props.title}
												onSubmit={this.onSubmit}
												onCancel={this.props.onCancel}
												isSubmitting={this.state.isSubmitting}
												item={this.props.item}/>
		);
	}

	onSubmit(data: DictionaryItem) {
		this.setState({isSubmitting: true}, () => {
			this.props.onUpdateItem(this.props.item.id,
				data,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success(`${this.props.title} has been updated.`, `${this.props.title} update`);
						this.props.onSuccess();
					});
				},
				(err) => this.setState({isSubmitting: false},
					() => {
						const title = `${this.props.title} update`;
						const message = this.props.errorHandler(err);
						if (message) {
							Toast.error(message, title)
						}
						else {
							notifyBugsnagAndShowToast(err, title)
						}

					})
			);
		});
	}
}